import _throttle from 'lodash/throttle'
import EventBus from '@/eventBus'
import Constants from '@/constant'
import mixpanelUtils from '@/utils/mixpanel.utils'

const MESSAGE_TYPES = {
  USER_ONLINE: 'uO',
  USER_ONLINE_COUNT_UPDATE: 'user-online-count',
}

function _handleOnlineCount(editor) {
  editor.$store.state.userOnline = editor.onlineCount

  if (editor.$store.state.currentUser.id) {
    if (!editor.$store.state.sharePresentation) {
      const percentLimit =
        (editor.$store.state.userOnline / editor.$store.state.plan.limit) *
        100
      if (percentLimit > 75 && percentLimit < 95) {
        editor.$store.state.onlineStatus = 2
      }
      if (percentLimit >= 95) {
        editor.$store.state.onlineStatus = 3
      }
      if (percentLimit <= 75 && editor.$store.state.onlineStatus != 1) {
        editor.$store.state.onlineStatus = 1
      }
    } else {
      editor.$store.state.onlineStatus = 1
    }

    mixpanelUtils.trackHostingEvent({
      presentation: editor.presentation,
      onlineCount: editor.onlineCount,
      maxOnlineCount: editor.maxOnlineCount,
    })
  }
}

const _handleOnlineCountThrottled = _throttle(_handleOnlineCount, 1000)

function handleUserOnline(socketData, editor) {
  const doc = {
    data: {
      audience: socketData.data.a,
      audienceName: socketData.data.n,
      audienceEmoji: socketData.data.e,
      quizOnline: socketData.data.q,
      audienceTeam: socketData.data.t,
    },
  }
  if (socketData.i) {
    doc.data.data = {
      id: socketData.data.i,
      answer: socketData.data.r,
    }
  }

  const params = {
    audience: doc.data.audience,
    audienceEmoji: doc.data.audienceEmoji,
    audienceName: doc.data.audienceName,
    offline: doc.data.offline,
    audienceTeam: doc.data.audienceTeam,
  }

  const objAudience = editor.$store.state.audiences[params.audience]
  if (!objAudience) {
    editor.$store.state.audiences[params.audience] = params
  } else {
    if (objAudience.audienceName !== params.audienceName) {
      editor.$store.state.audiences[params.audience].audienceName = params.audienceName
    }
    if (objAudience.audienceEmoji !== params.audienceEmoji) {
      editor.$store.state.audiences[params.audience].audienceEmoji = params.audienceEmoji
    }
    if (objAudience.audienceTeam !== params.audienceTeam) {
      editor.$store.state.audiences[params.audience].audienceTeam = params.audienceTeam
    }
    if (objAudience.offline !== params.offline) {
      editor.$store.state.audiences[params.audience].offline = params.offline
    }

    if (doc.data.data) {
      if (
        editor.$store.state.audiences[params.audience][doc.data.data.id] !== true
      ) {
        editor.$store.state.audiences[params.audience][doc.data.data.id] = doc.data.data.answer
      }
    }
  }

  if (editor.isQuizLobbyScreen || editor.isQuizResultScreen || editor.slideActive.type === 'qrcode') {
    editor._getAudienceOnlineJoinQuiz()
    if (editor.$store.state.presentation.teamPlay) {
      editor._getAndSetPayloadAudienceTeamName(params)
    }
  }
  if (editor.$store.state.slideActive.type === 'spinnerWheel' && editor.$store.state.slideActive.wheelStatus !== 'spinning') {
    editor._handleEventAudienceOnOff()
  }
}

function handleUserOnlineCountUpdate(doc, editor) {
  if (doc.data || doc.data === 0) {
    if (doc.data > editor.userOnline) {
      EventBus.$emit('userOnlineCount')
      if (editor.isPresenting && !editor.sharePresentation) {
        editor.updatePresentationSessionOnlineCount(editor.presentation.id, doc.data)
      }
    }

    editor.onlineCount = doc.data
    _handleOnlineCountThrottled(editor)
    if (!editor.maxOnlineCount || editor.onlineCount > editor.maxOnlineCount) {
      editor.maxOnlineCount = editor.onlineCount
    }
  }

  if (doc.off) {
    if (editor.$store.state.audiences[doc.off]) {
      editor.$store.state.audiences[doc.off].offline = true
      const offlineAudience = editor.$store.state.audiences[doc.off]
      if (editor.presentation.teamPlay) {
        editor._getAndSetPayloadAudienceTeamName(offlineAudience)
      }
    }

    if (editor.userOnline < 60 && editor.slideActive.type == 'pickAnswer'
            && editor.slideActive.quizStatus == Constants.QuizStatuses.LOBBY_SCREEN) {
      editor._getAudienceOnlineJoinQuiz()
    }
  }
}

const UserOnlineWebSocketSubscriber = {
  [MESSAGE_TYPES.USER_ONLINE]: handleUserOnline,
  [MESSAGE_TYPES.USER_ONLINE_COUNT_UPDATE]: handleUserOnlineCountUpdate,
}

export default UserOnlineWebSocketSubscriber
